var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleDashed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,3.1C5.2,4.1,4,5.3,3.1,6.6L4.9,8c0.8-1.2,1.8-2.2,3-3.1L6.5,3.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,11.8l-2.2-0.7C0.2,12.7,0,14.3,0,16h2.3C2.3,14.6,2.5,13.1,3,11.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8,21c0.5,1.6,1.3,3.1,2.3,4.5l1.8-1.4C4.1,23,3.4,21.7,3,20.3L0.8,21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6,28.9c1.4,1,2.9,1.8,4.5,2.3l0.7-2.2c-1.3-0.5-2.6-1.1-3.8-1.9L6.6,28.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,0.8L11.8,3c1.4-0.5,2.8-0.7,4.2-0.7V0C14.3,0,12.7,0.2,11.1,0.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4,28.9c1.3-1,2.5-2.2,3.5-3.5L27.1,24c-0.8,1.2-1.9,2.2-3.1,3.1L25.4,28.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29,20.2l2.2,0.7c0.5-1.6,0.8-3.2,0.8-4.9h-2.3C29.7,17.4,29.5,18.9,29,20.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1,11c-0.5-1.6-1.3-3.1-2.3-4.5L27,7.9c0.8,1.2,1.5,2.4,1.9,3.8L31.1,11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3,3c-1.4-1-2.9-1.8-4.5-2.3l-0.7,2.2c1.3,0.5,2.6,1.1,3.8,1.9L25.3,3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9,31.2L20.2,29c-1.4,0.5-2.8,0.7-4.2,0.7V32C17.7,31.9,19.3,31.6,20.9,31.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    className: "st0",
    width: 32,
    height: 32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDashed);
export default __webpack_public_path__ + "static/media/circle_dashed.12220e14.svg";
export { ForwardRef as ReactComponent };